import React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { useEffect } from "react";

const AddFunction = ({
  openDialog,
  handleClose,
  register,
  handleSubmit,
  errors,
  onAddFunctionSubmit,
  departmentList,
  setDeptNameForFunction,
  formData,
  isUpdateButton,
  isEditMode,
  setIsUpdateButton,
  setValue
}) => {
  
  const { content } = departmentList;
//   useEffect(()=>{
// console.log('formData',formData)
//   })
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>
                {!isEditMode ? "Add Function" : "Edit Function"}
              </b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={10} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 1 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Select-Department-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Department
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Select Department"
                          name="deptId"
                          fullWidth
                          size="small"
                          autoComplete="off"
                          {...register("deptId", { required: true })}
                          defaultValue={formData?.department?.departmentId}
                          error={Boolean(errors?.deptId)}
                          helperText={errors?.deptId?.message}
                          onChange={() => setIsUpdateButton(false)}
                        >
                          {content &&
                            content.map((d) => {
                              return (
                                <MenuItem
                                  native
                                  key={d.departmentId}
                                  sx={{ width: "100%" }}
                                  value={d.departmentId}
                                  size="small"
                                  // onClick={() =>
                                  //   setDeptNameForFunction(d.name)
                                  // }
                                >
                                  {d.deptCode} - {d.name}
                                </MenuItem>
                              );
                            })}        
                        </Select>
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.deptId?.message}
                          </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        name="functionCode"
                        label="Function Code"
                        placeholder="Enter Function Code"
                        fullWidth
                        required
                        size="small"
                        autoComplete="off"
                        {...register("functionCode", { required: true })}
                        error={Boolean(errors?.functionCode)}
                        helperText={errors?.functionCode?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("functionCode", str.trim());
                         
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        name="name"
                        label="Function Name"
                        placeholder="Enter Function Name"
                        fullWidth
                        required
                        size="small"
                        autoComplete="off"
                        {...register("name", { required: true })}
                        error={Boolean(errors?.name)}
                        helperText={errors?.name?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("name", str.trim());
                         
                        }}
                      />
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 1, pl: 37 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddFunctionSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddFunction;
  